export default "__VITE_ASSET__P$gouBnP__"